import request from '../utils/request';

// Excel导入用户
export const importUsers = (formData) => {
  return request.post('/admin/users/import', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

// 获取用户列表
export const getUserList = (params) => {
  return request.get('/admin/users', { params });
};

// 添加用户
export const addUser = (data) => {
  return request.post('/admin/users', data);
};

// 重置用户密码
export const resetPassword = (id) => {
  return request.post(`/admin/users/${id}/reset-password`);
};

// 修改用户资料
export const updateUser = (id, data) => {
  return request.put(`/admin/users/${id}`, data);
};

// 获取部门列表
export const getDepartments = () => {
  return request.get('/admin/departments');
};

// 添加部门
export const addDepartment = (data) => {
  return request.post('/admin/departments', data);
};

// 删除部门
export const deleteDepartment = (id) => {
  return request.delete(`/admin/departments/${id}`);
};

// 修改部门
export const updateDepartment = (id, data) => {
  return request.put(`/admin/departments/${id}`, data);
};

// 更新质量方针内容
export const updateContent = (id, data) => {
  return request.put(`/admin/contents/${id}`, data);
};

// 上传音频文件
export const uploadAudio = (formData) => {
  return request.post('/admin/contents/upload-audio', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

// 获取题目列表
export const getQuestions = (params) => {
  return request.get('/admin/questions', { params });
};

// 添加题目
export const addQuestion = (data) => {
  return request.post('/admin/questions', data);
};

// 更新题目
export const updateQuestion = (id, data) => {
  return request.put(`/admin/questions/${id}`, data);
};

// 删除题目
export const deleteQuestion = (id) => {
  return request.delete(`/admin/questions/${id}`);
};

// 获取完形填空列表
export const getFillBlanks = (params) => {
  return request.get('/admin/fillblanks', { params });
};

// 添加完形填空
export const addFillBlank = (data) => {
  return request.post('/admin/fillblanks', data);
};

// 更新完形填空
export const updateFillBlank = (id, data) => {
  return request.put(`/admin/fillblanks/${id}`, data);
};

// 删除完形填空
export const deleteFillBlank = (id) => {
  return request.delete(`/admin/fillblanks/${id}`);
};

// 获取内容列表
export const getContents = () => {
  return request.get('/admin/contents');
};

// 获取统计数据
export const getStatistics = () => {
  return request.get('/admin/statistics');
};

// 修改用户密码（管理员操作）
export const changeUserPassword = (id, data) => {
  return request.put(`/admin/users/${id}/password`, data);
};

// 获取登录日志
export const getLoginLogs = (params) => {
  return request.get('/admin/login-logs', { params });
};

// 获取承诺列表
export const getPromises = (params) => {
  return request.get('/admin/promises', { params });
};

// 管理员修改自己的密码
export const changeAdminPassword = (data) => {
  return request.put('/admin/profile/password', data);
};

// 导出报表
export const exportData = (type) => {
  return request.get('/admin/export', {
    params: { type },
    responseType: 'blob'
  });
};

// 导出学习数据
export const exportLearningData = (fields) => {
  return request.get('/admin/export-data', {
    params: { fields }
  });
};

// 获取站点设置
export const getSiteSettings = () => {
  return request.get('/admin/settings');
};

// 更新站点设置
export const updateSiteSettings = (data) => {
  return request.put('/admin/settings', data);
};

// 上传站点图片
export const uploadSiteImage = (formData) => {
  return request.post('/admin/settings/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

// IP规则管理
export const getIpRules = () => request.get('/admin/ip-rules');
export const addIpRule = (data) => request.post('/admin/ip-rules', data);
export const deleteIpRule = (id) => request.delete(`/admin/ip-rules/${id}`);

// 安全设置
export const getSecuritySettings = () => request.get('/admin/security-settings');
export const updateSecuritySettings = (data) => request.put('/admin/security-settings', data);

// 评分项管理
export const getRatingItems = () => request.get('/admin/rating-items');
export const addRatingItem = (data) => request.post('/admin/rating-items', data);
export const updateRatingItem = (id, data) => request.put(`/admin/rating-items/${id}`, data);
export const deleteRatingItem = (id) => request.delete(`/admin/rating-items/${id}`);

// 用户管理
export const toggleUserStatus = (id) => request.put(`/admin/users/${id}/status`);
export const deleteUser = (id) => request.delete(`/admin/users/${id}`);
export const clearRecords = () => request.post('/admin/users/clear-records');
export const clearUserRecords = (id) => request.post(`/admin/users/${id}/clear-records`);

// MCP API Key
export const getMcpKey = () => request.get('/admin/mcp-key');
export const generateMcpKey = () => request.post('/admin/mcp-key');

// 检查修复学习状态
export const fixProgressStatus = () => request.post('/admin/users/fix-progress-status');
